// extracted by mini-css-extract-plugin
export default {"layoutContainer":"AuthLayout_layoutContainer__KSbwO","content":"AuthLayout_content__KQ55m"};